const defaultLength = 50;

export function truncate(text: string, length: number = defaultLength) {
  if (text.length > length) {
    return text.slice(0, length);
  } else {
    return text;
  }
}

export function truncateWithEllipsis(
  text: string,
  length: number = defaultLength,
) {
  if (text.length > length) {
    return text.slice(0, length) + '...';
  } else {
    return text;
  }
}
